import NumberFormat, { NumberFormatProps } from 'react-number-format'
import { TextField, InputAdornment, InputProps, Tooltip } from '@mui/material'
import { Info } from '@mui/icons-material'

import { sentenceCase } from '@/utils'
import { StateSchema } from '@/hooks/form/models'
import { CurrencyCodeEnum } from '@/enums/currency-code.enum'

interface Props extends NumberFormatProps {
  label?: string
  name: string
  state: StateSchema
  handleOnChange?: (name: string, value: any) => void
  InputPropsAdornment?: Partial<InputProps>
  inputPropMaxLength?: number
  disableInputPropsAdornment?: boolean
  prefix?: string
  tooltipMessage?: string
  currency?: string
  fullwidth?: boolean
}

const NumberFormatCustom = ({
  label,
  name,
  state,
  handleOnChange,
  InputPropsAdornment,
  inputPropMaxLength,
  disableInputPropsAdornment,
  prefix,
  tooltipMessage,
  currency,
  fullwidth,
  ...props
}: Props) => {
  const { value, error } = state[name]

  const { onValueChange } = props

  return (
    <>
      {tooltipMessage && (
        <Tooltip sx={{ paddingLeft: 1 }} arrow title={tooltipMessage}>
          <Info />
        </Tooltip>
      )}
      <NumberFormat
        fullWidth={fullwidth}
        value={value}
        name={name}
        error={error ? error.length > 0 : false}
        helperText={sentenceCase(error, true)}
        customInput={TextField}
        prefix={prefix !== undefined ? prefix : '$'}
        type="text"
        className="number-format"
        label={label}
        thousandSeparator=","
        onValueChange={
          onValueChange
            ? onValueChange // eslint-disable-line
            : ({ value: v }) => handleOnChange && handleOnChange(name, v)
        }
        InputProps={
          disableInputPropsAdornment
            ? undefined
            : InputPropsAdornment
            ? InputPropsAdornment // eslint-disable-line
            : {
                endAdornment: (
                  <InputAdornment position="end">
                    {currency || CurrencyCodeEnum.USD}
                  </InputAdornment>
                ),
                inputProps: {
                  maxLength: inputPropMaxLength || 1000,
                },
              }
        }
      />
    </>
  )
}

export default NumberFormatCustom
